<template>
  <div class="">
        <!-- There is no error -->
        <v-form ref="subscribeform" v-model="formvalid" lazy-validation >

        <v-container text-xs-center>
          <v-row class="" align="center" justify="center">
            Subscribe to story updates for:
          </v-row>
          <v-row class="headline" align="center" justify="center">
            {{$route.params.title}}
          </v-row>

          <v-container v-if="success">
              <v-row class="" align="center" justify="center">
                Subscription successful!
              </v-row>

              <v-row class="headline" align="center" justify="center">
                <router-link :to="{name:'TitlePage', params:{'storyID':$route.params.storyID}}" class="title">
                  Back to the story.
                </router-link>
              </v-row>

          </v-container>
          <v-container v-else>
            <v-text-field
                v-model="emailAddr"
                :rules="emailRules"
                outlined
                clearable
                label="Email Address"
                type="text"
                id="emailField"
              ></v-text-field>

            <v-row class="headline" align="center" justify="center">

              <vue-recaptcha
                  ref="invisibleRecaptcha"
                  size="invisible"
                  :sitekey="sitekey"
                  @verify="onVerify"
                  @expired="onExpired"
                  >
                  <v-btn  class="success" :disabled="!formvalid" :loading="loading">
                    Subscribe
                  </v-btn>
              </vue-recaptcha>
            </v-row>
          </v-container>
          <div v-if="errtext" class="red--text">
            {{errtext}}
          </div>

        </v-container>
      </v-form>
  </div>
</template>

<script>
import config from '../config.js'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'Subscribe',
  components: {
    VueRecaptcha
  },
  props: ['title', 'storyID'],
  data () {
    return {
      sitekey: config.recaptchaSiteKey,
      formvalid: false,
      errtext: null,
      loading: false,
      emailAddr: null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      success: false
    }
  },
  mounted () {
  },
  methods: {
    subscribe (recaptchaToken) {
      // validate!
      this.formvalid = this.$refs.subscribeform.validate()
      if (this.formvalid === false) {
        return
      }

      const dynFunction = config.getFunctions().httpsCallable('dynFunction')

      this.success = false
      this.loading = true
      this.errtext = null
      dynFunction({
        call: 'subscribeToStory',
        storyID: this.$route.params.storyID,
        email: this.emailAddr,
        recaptchaToken: recaptchaToken

      }).then((rc) => {
        if (rc.data.status === 'ADDED') {
          this.success = true
          this.loading = false
        }
      }).catch((err) => {
        this.loading = false
        console.error('Error testEmail: ' + err)
        this.errtext = err
        this.resetRecaptcha()
      })
    },
    onVerify: function (response) {
      // Recaptcha Verify
      // console.log('Verify: ' + response)

      // Call to the server to verify and respond.
      this.subscribe(response)
    },
    onExpired: function () {
      // Recaptcha expired
      console.log('Expired')
    },
    resetRecaptcha () {
      this.$refs.invisibleRecaptcha.reset() // Direct call reset method
    }
  }
}
</script>
<style scoped>
#emailfield {
      width: 400px;
    }

</style>
